import fx from "../../utils/fx";
import AxiosInterceptor from 'api/interceptor';

const role = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return role.get('/guard/roles?' + qstr);
  },
  find(id) {
    return role.get('/guard/roles/' + id);
  },
  create(inputs) {
    return role.post('/guard/roles', inputs);
  },
  update(id, inputs) {
    return role.put('/guard/roles/' + id, inputs);
  },
  delete(id) {
    return role.delete('/guard/roles/' + id);
  }
};
